<!--
 * @Author: tianshuai 1446360207@qq.com
 * @Date: 2024-08-05 16:03:23
 * @LastEditors: tianshuai 1446360207@qq.com
 * @LastEditTime: 2024-10-23 15:35:59
 * @FilePath: \惠宾官网\src\views\productCenter.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="product-center-box h100">
    <div class="product-center-content">
      <div class="prouct-banner-box">
        <img src="@/assets/img/product-banner1.jpg" class="center-block w100"  alt=""/>
      </div>
      <div class="content-text-box container xs-column-center" ref="content-text-box">
        <div class="tab-lable-box xs-content-left">
          <div class="tab-item-title hidden-xs">产品与解决方案</div>
          <div class="tab-item-box" :class="{'tab-active':activeTab.id==item.id}"
          @click="setActiveTab(item)"
          v-for="(item,index) in tabLableList" :key="index">
            <div class="lable-radio"></div>
            <div class="tab-lable-item cursor-pointer">{{ item.lable }}</div>
          </div>
        </div>
        <div class="tab-content-box">
          <div class="big-title-box">
            <span class="big-title-text">{{context.title}}</span>
            <div class="title-line-x"></div>
          </div>
          <div class="content-item-box"  v-html="context.content">
          </div>
        </div>
      </div>
    </div>
    <bottom-footer @active="getActive"></bottom-footer>
  </div>
</template>

<script>
import bottomFooter from "@/components/bottomFooter.vue";

export default {
  name: "productCenter",
  components: {
    bottomFooter,
  },
  data() {
    return {
      id:-1,
      elTop:0,
      activeTab:"",
      context:"",
      tabLableList:[
        {
          id:"1",
          lable:"门诊预约挂号系统"
        },
        {
          id:"2",
          lable:"医院智能排队叫号系统"
        },
        {
          id:"3",
          lable:"互联网医院"
        },
        {
          id:"4",
          lable:"门诊综合服务平台/外联平台"
        },
        {
          id:"5",
          lable:"医院综合支付管理系统"
        },
        {
          id:"6",
          lable:"医院综合对账管理系统"
        },
        {
          id:"7",
          lable:"智能住院管理系统"
        },
        {
          id:"8",
          lable:"日间手术全流程信息化管理平台"
        },
        {
          id:"9",
          lable:"体检系统"
        },
        {
          id:"10",
          lable:"手麻系统"
        },
        {
          id:"11",
          lable:"PACS系统"
        },
        {
          id:"12",
          lable:"区域健康服务平台"
        }
      ],
    };
  },
  watch:{
    
  },
  created () {
    this.setActiveTab(this.tabLableList[0]);
   
  },
  mounted() {
    console.log(this.$route.query.id);
    
   if(this.$route.query.id>0){
    this.getElTop();
   } 
  },
  methods: {
      getActive(e){
        
        this.id=e.id;
        this.getElTop();
      },
      getElTop(){
        console.log("product:执行getElTop");
        
        let id=this.$route.query.id;
        if(this.id>0){
          id=this.id;
        }
        let item=this.tabLableList.filter((item,index)=>{
          if(item.id==id){
            return item;
          }
        });
        if(item[0]){
          this.setActiveTab(item[0]);
        }
        
        let time=setTimeout(()=>{
          this.$nextTick(()=>{
            console.log("product:",$(".content-text-box"));
            
            if($(".content-text-box").offset()){
              this.elTop=$(".content-text-box").offset().top;
              $("html,body").animate({scrollTop: this.elTop}, 800);
            }
            clearTimeout(time);
            time=null;
          })
        },1000);
      },
      setActiveTab(item){
        if(this.activeTab.id!=item.id){
          this.activeTab=item;
        }
        this.getContent();
        
      },
      getContent(){
        this.$http.post("/mock/content",{
          type:this.activeTab.id
        }).then(res=>{
          
          this.context=res.data;
          // console.log(this.context);
          
        }).catch(err=>{
          console.log(err);

        })
      }
  },
};
</script>

<style scoped lang="scss">
@mixin content-text-font{
	font-size: 1.6rem;
	// color: #333333;
	font-weight: 400;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	line-height: 2.4rem;
}
.product-center-box {
  .product-center-content {
    .prouct-banner-box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .banner-desc-box {
        position: absolute;
        left: 20%;
        top: 50%;
        transform: translateY(-50%);
        .banner-desc-content {
          .banner-desc-title {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 4.4rem;
            color: #ffffff;
          }
          .banner-desc-text {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 2rem;
            color: #ffffff;
          }
        }
        .more-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 16rem;
          height: 4.8rem;
          margin-top: 5.8rem;
          background: #087aff;
          border-radius: 10rem;
          border: 1px solid #087aff;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 1.6rem;
          color: #ffffff;
        }
        .more-icon {
          width: 1.4rem;
          height: 1.4rem;
        }
      }
      .prouct-banner1 {
        width: 100%;
      }
    }
  }
}
.content-text-box {
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding-top: 3rem;
  padding-bottom: 3rem;
  background: no-repeat;
  .tab-lable-box {
    width: 25%;
    height: 100%;
    border: 1px solid #d6d6d6;
    border-radius: 1.6rem 0.4rem 0px 0px;
    overflow: auto;
    // position: sticky;
    // top: 11rem;

    .tab-item-title {
      padding: 2rem 1.5rem;
      border-radius: 1.6rem 0.4rem 0px 0px;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      background: #002880;
    }
    .tab-item-box {
      display: flex;
      align-items: center;
      padding-left: 1.5rem;
      padding-right: 0;
      .lable-radio {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        background: #b5b5b5;
      }

      .tab-lable-item {
        width: 100%;
        padding: 2rem 1.5rem 2rem 1.5rem;

        border-bottom: 1px solid #d6d6d6;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 1.6rem;
        color: #666666;
        box-sizing: border-box;
      }
    }
    
    .tab-active {
      
      .lable-radio{
        background-color: #002880;
      }
      .tab-lable-item{
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #002880;
      }
    }
  }
  .tab-content-box {
    width: 75%;
    height: 100%;
    padding-left: 6rem;
    box-sizing: border-box;
    .big-title-box{
      display: flex;
      flex-direction: column;
      .big-title-text{
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 3.6rem;
        color: #333333;
      }
      .title-line-x{
        width: 13%;
        height: 2px;
        background: #002880;
      }
    }
    
  }
}
::v-deep .content-title{
  margin-top: 7rem;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 2.2rem;
  color: #002880;
}
::v-deep .content-desc{
  margin-top: 2.4rem;
  @include content-text-font;
  div{
    @include content-text-font;
  }
  p{
    @include content-text-font;
  }
}
::v-deep  .step-img{
  display: inline-block;
  width: 40%;
  min-width: 20rem;
  margin-bottom: 0.5rem;
}
::v-deep .anli-yiyuan-img{
  display: inline-block;
  width: 19%;
}
::v-deep .btn1{
  width: 86px;
  height: 24px;
  margin-top: 1rem;
  background-color: #fff;
  color: #3486fc;
  font-size: 12px;
  box-shadow: 0 0 3px #3486fc;
  border-radius: 15px;
  text-align: center;
  line-height: 24px;
  overflow: hidden;
}
::v-deep .btn2{
  width: 86px;
    height: 24px;
    margin-top: 1rem;
    background-color: #e7eefe;
    color: #3486fc;
    font-size: 12px;
    box-shadow: 0 0 3px #3486fc;
    border-radius: 15px;
    text-align: center;
    line-height: 24px;
    overflow: hidden;
}
::v-deep .btn3 {
    width: 86px;
    height: 24px;
    margin-top: 1rem;
    background-color: transparent;
    color: #3486fc;
    font-size: 12px;
    // box-shadow: 0 0 3px #3486fc;
    border-radius: 15px;
    text-align: center;
    line-height: 24px;
    overflow: hidden;
}
::v-deep .content-desc .pay{
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('https://cpjs.hbjk114.com/img/k10.e5cd5883.png');
  background-size: 100% 100%;
  color:#ffffff;
  font-size: 2rem;
  font-weight: 700;
  box-sizing: border-box;
}
::v-deep .pay-item-box{
  width: 80%;
  display: flex;
  padding: 3rem 0;
  
  justify-content: space-around;
  box-shadow: 0 0 4px #ccc;
}
::v-deep .anli-yiyuan-img1{
  width: 5.4rem;
}
::v-deep .anli-yiyuan1{
  min-width: 49%;
  padding: 2rem 3rem;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 4px #ccc;
}
::v-deep .xiaoguo-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 33px 16px;
  margin-top: 2rem;
  background-image: url(https://cpjs.hbjk114.com/img/a8.a6412665.png);
  background-size: 100% 100%;
}
::v-deep .bg-img1{
  background-image: url('https://cpjs.hbjk114.com/img/v1.8548eff3.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img2{
  background-image: url('https://cpjs.hbjk114.com/img/v2.4f0d26a6.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img3{
  background-image: url('https://cpjs.hbjk114.com/img/v3.5ece1035.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img4{
  background-image: url('https://cpjs.hbjk114.com/img/v4.0c4e7232.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img5{
  background-image: url('https://cpjs.hbjk114.com/img/v6.b00006a6.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img6{
  background-image: url('https://cpjs.hbjk114.com/img/v1.8548eff3.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img7{
  background-image: url('https://cpjs.hbjk114.com/img/re2.ea209a04.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img8{
  background-image: url('https://cpjs.hbjk114.com/img/re2.ea209a04.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img9{
  background-image: url('https://cpjs.hbjk114.com/img/re4.66bf1a8f.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img10{
  background-image: url('https://cpjs.hbjk114.com/img/re5.390d60d6.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img11{
  background-image: url('https://cpjs.hbjk114.com/img/ex2.10b643b6.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img12{
  background-image: url('https://cpjs.hbjk114.com/img/ex4.ef201fc4.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img13{
  background-image: url('https://cpjs.hbjk114.com/img/ex5.5aa644dc.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img14{
  background-image: url('https://cpjs.hbjk114.com/img/ex4.ef201fc4.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img15{
  background-image: url('https://cpjs.hbjk114.com/img/ex6.5711f858.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img16{
  background-image: url('https://cpjs.hbjk114.com/img/h6.5c7a1f08.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img17{
  background-image: url('https://cpjs.hbjk114.com/img/h7.95f8e1b3.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img18{
  background-image: url('https://cpjs.hbjk114.com/img/h8.d5c671ae.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img19{
  background-image: url('https://cpjs.hbjk114.com/img/h9.e1849182.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img20{
  background-image: url('https://cpjs.hbjk114.com/img/h10.5f8d7a04.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

::v-deep .bg-img21{
  background-image: url('../assets/img/img9.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img22{
  background-image: url('../assets/img/img10.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img23{
  background-image: url('../assets/img/img11.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .bg-img24{
  background-image: url('../assets/img/img12.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::v-deep .shadow-xy{
  box-shadow: 0 0 12px #bbbbbb;
}
::v-deep .round-box{
  display: flex;
  
}
::v-deep .round-desc-box{
    
}
::v-deep .round-num{
  font-size: 18px;
  font-weight: 600;
  color: #3a8afc;
}
::v-deep .round-title-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    
  }
::v-deep .round-title{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  width: 60px;
  height: 60px;
  background-color: #3e8cfc;
  border-radius: 50%;
  border: 5px solid #abcbfe;
  margin-right: 18px;
}
::v-deep .round-jian{
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0e0e0c;
  font-size: 16px;
  font-weight: 600;
  width: 70px;
  text-align: center;

}
::v-deep .title-color1{
  background-color: #25d897;
  border-color: #8bebbe;
}
::v-deep .subtitle{
  font-size: 2rem;
}
</style>
